import { DGA_AUTH_TRANSACTION_ACTION_TYPE } from "./dga-auth-transaction.action";

export const DGA_AUTH_TRANSACTION_CODES = {
	emptyXmlDSig: "E_VALIDATION_EMPTYXMLDSIG",
	invalidXmlDSig: "E_VALIDATION_INVALIDXMLDSIG",
	invalidCprLength: "E_VALIDATION_INVALIDCPRLENGTH",
	invalidCprFormat: "E_VALIDATION_INVALIDCPRFORMAT",
	authenticationError: "E_AUTHENTICATION",
	authProviderError: "E_AUTHENTICATION_PROVIDERERROR",
	authProviderTimeout: "E_AUTHENTICATION_PROVIDERTIMEOUT",
	authProviderAuthentication: "E_AUTHENTICATION_PROVIDERAUTHENTICATION",
	verificationStatus: {
		start: "M_VERIFICATION_START",
		completed: "M_VERIFICATION_SUCCESS",
		failed: {
			generic: "E_VERIFICATION_FAILED",
			cprNumberNotFound: "E_CPRNUMBER_NOTFOUND",
			cprNumberAlreadyRegistered: "E_CPRNUMBER_ALREADY_REGISTERED",
		},
	},
	experian: {
		tokenValidation: "E_VALIDATION_TOKEN",
		invalidRequest: "E_PERSONALDATA_INVALIDREQUEST",
		timeOut: "E_PERSONALDATA_TIMEOUT",
		limitExceeded: "E_PERSONALDATA_LIMITEXCEEDED",
		unknownError: "E_PERSONALDATA_UNKNOWNERROR",
	},
};

export const DGA_REGISTRATION_PARTIAL_FLOW_CODES = [
	DGA_AUTH_TRANSACTION_CODES.experian.invalidRequest,
	DGA_AUTH_TRANSACTION_CODES.experian.limitExceeded,
	DGA_AUTH_TRANSACTION_CODES.experian.timeOut,
	DGA_AUTH_TRANSACTION_CODES.experian.tokenValidation,
	DGA_AUTH_TRANSACTION_CODES.experian.unknownError,
];

export const DGA_AUTH_TRANSACTION_MESSAGE_CONTEXT = {
	getVerificationStatus: DGA_AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatus,
	initializeAuthTransaction: DGA_AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction,
	getExperianData: DGA_AUTH_TRANSACTION_ACTION_TYPE.getExperianData,
};
